import Templates from "./templates";
import _ from "../../../../lib/lodash.custom.min";
import $ from "jquery";
import viewHelpers from "./view-helper";
import {hash} from "./hash-control";
import {numFormat, rangeText, formatDataVersion, addSaikoClass} from "../modules/util";
import {courseCalendarTemplateData} from "../modules/course-calendar";
import {courseImageURL} from "../../../util/common";
import {detailParam} from "../modules/transition";
import {PAGE_WIDTH, REVIEW_HOTELS_PER_PAGE, RANKING_LIMIT, KODAWARI, HOTEL_ORDER_ITEM_PER_PAGE, SORT} from "./config";
import {LAYER_SPEED} from "../common-config";
import {slideCalendar} from "../modules/animation";

/*
 * htmlを描画するための関数群
 * （全てrenderXXXなので関数名にrenderは不要）
 */
export default {
	dataVersion: function(ev) {
		var version = ev.data.def.dataVersion[0];
		$("#forcia-data-version").html(formatDataVersion(version));
	},
	mainLayer: function(ev) {
		var store = ev.data;
		if (_.isEmpty(store.state.subLayer)) {
			const data = Object.assign({
				currentArrivalLayer: viewHelpers.currentArrivalLayer
			}, store);
			const basic = Templates.basicCondition(data);
			const detail = Templates.detailCondition(data);
			$("#forcia-template-basic-condition").html(basic);
			$("#forcia-template-detail-condition").html(detail);
			initDetailConditionDisplay(store);
		}
	},
	pager: function(ev) {
		const state = ev.data.state;
		if (!state.ConditionState) return;
		const currentPage = +state.page;
		let itemPerPage;
		let dataCount;
		const params = state.getParam();
		if (params.sort === "hotel" || params.sort === "hotel_back") {
			dataCount = Number(state.ConditionState.hotelListCount[0]);
			itemPerPage = HOTEL_ORDER_ITEM_PER_PAGE;
		} else {
			dataCount = Number(state.ConditionState.dataCount[0]);
			itemPerPage = state.limit;
		}

		const range = viewHelpers.pageRange({
			width: PAGE_WIDTH,
			total: dataCount,
			limit: itemPerPage,
			current: currentPage
		});
		const pager = _.range(range.min, range.max + 1).map((val) => {
			return {
				num: val,
				isCurrent: val === currentPage,
				offset: val - currentPage
			};
		});
		const hasPrev = currentPage !== 1;
		const lastPage = pager[pager.length - 1];
		const hasNext = lastPage && !lastPage.isCurrent;

		const pagerTopHtml = Templates.pagerTop({pager, hasPrev, hasNext});
		const pagerBottomHtml = Templates.pagerBottom({pager, hasPrev, hasNext});
		$("#forcia-template-pager-top").html(pagerTopHtml);
		$("#forcia-template-pager-bottom").html(pagerBottomHtml);
	},
	hidePager: function() {
		$("#forcia-template-data-count").hide();
		$("#forcia-template-pager-top").hide();
		$("#forcia-template-pager-bottom").hide();
	},
	showPager: function() {
		var isHidden = $("#forcia-template-data-count").is(":hidden")
					&& $("#forcia-template-pager-top").is(":hidden")
					&& $("#forcia-template-pager-bottom").is(":hidden");
		if (isHidden) {
			$("#forcia-template-data-count").show();
			$("#forcia-template-pager-top").show();
			$("#forcia-template-pager-bottom").show();
		}
	},
	sort: function(ev) {
		$("#forcia-sort").val(ev.data.state.sort);
	},
	listHtml: function(ev) {
		var store = ev.data;
		var html = store.state.ListMobile.html.join("");
		$("#forcia-template-list").html(html);
	},
	hotelListHtml: function(ev) {
		var store = ev.data;
		var html = store.state.HotelListMobile.html.join("");
		$("#forcia-template-list").html(html);
		viewHelpers.hotelCheckBox(ev);
	},
	hotelListErrorHtml: function(ev) {
		const hotelListErrorHtml = Templates.hotelListErrorPage();
		$("#forcia-template-list").html(hotelListErrorHtml);
	},
	ranking: function(ev) {
		const courses = ev.data.state.RankingList.course.slice(0, RANKING_LIMIT);
		const html = Templates.ranking({
			detailParam,
			courses,
			rangeText,
			numFormat,
			courseImageURL
		});
		$("#forcia-template-ranking").html(html);
	},
	history: function(ev) {
		const html = ev.data.state.HistListMobile.html.join("");
		$("#forcia-template-history").html(html);
	},
	courseCalendar: function(ev) {
		const isOpened = ev.data.state.courseCalendarLayer;
		if (isOpened) {
			const index = ev.data.state.courseListIndex;
			const course = ev.data.state.ListMobile.course;
			const courseCalendarFuncs = courseCalendarTemplateData({
				calendarHash: ev.data.def.calendarHash,
				minPrices: course[index].ary_minprice.split("\t"),
				maxPrices: course[index].ary_maxprice.split("\t"),
				stocks: course[index].ary_stock.split("\t"),
				startDateIndex: ev.data.def.startDate.index,
				saikoIndexes: course[index].ary_saikoIndex.split("\t"),
				withTourConductor: course[index].withTourConductor,
				dataVersion: ev.data.def.dataVersion[0]
			});
			const styleLeft = ev.data.state.monthIndex ? -ev.data.state.monthIndex * 100: 0;
			const html = Templates.courseCalendar(Object.assign(
						courseCalendarFuncs, {
							months: ev.data.def.months,
							styleLeft: styleLeft,
							addSaikoClass: addSaikoClass
						}));
			window.__forcia__.scrollY = window.scrollY;

			$("#forcia-course-calendar").html(html);
			$("#forcia-course-calendar").animate({left: 0}, LAYER_SPEED, () => {
				$("body").css({backgroundColor: "#e9ecf0"});
				$("#forcia-course-calendar").css({position: "relative"});
				$("#wrapper").css({display: "none"});
				window.scrollTo(0, 0);
			});
			hash.openCourseCal();
		} else {
			$("#forcia-course-calendar").css({left: "120%", position: "fixed"});
			$("#wrapper").css({display: "block"});
			hash.closeCourseCal();

			// カレンダーを閉じた時にスクロール位置を元の場所に戻す
			// 非同期にしないとスクロールが動作しない
			setTimeout(function(){
				window.scrollTo(0, window.__forcia__.scrollY);
			}, 1);
		}
	},
	dataCount: function(ev) {
		var dataCount;
		var itemPerPage;
		var state = ev.data.state;
		var params = state.getParam();
		if (!state.page || !state.ConditionState) {
			return;
		}
		if (params.sort === "hotel" || params.sort === "hotel_back") {
			dataCount = Number(state.ConditionState.hotelListCount[0]);
			itemPerPage = HOTEL_ORDER_ITEM_PER_PAGE;
		} else {
			dataCount = Number(state.ConditionState.dataCount[0]);
			itemPerPage = state.limit;
		}


		var html;
		if (!dataCount) {
			html = "";
		} else {
			var from = (state.page - 1) * itemPerPage + 1;
			var to = Math.min(dataCount, (from - 1) + itemPerPage);
			html = numFormat(dataCount) + "件中 " + from + "-" + to + "件目";
		}
		$("#forcia-template-data-count").html(html);
	},
	currentConditions: function(ev) {
		var store = ev.data;
		var html = Templates.currentConditions(store);
		$("#forcia-template-current-conditions").html(html);
	},
	region0: function(ev) {
		if (ev.data.state.subLayer !== "region0") return;
		var store = ev.data;
		var html = Templates.region(Object.assign({regions: viewHelpers.getRegionData(store), numFormat}, store));
		$("#forcia-template-arrival-region0").html(html);
	},
	country0: function(ev) {
		if (ev.data.state.subLayer !== "country0") return;
		var store = ev.data;
		var html = Templates.country0(Object.assign({regions: viewHelpers.getMapData(store), numFormat}, store));
		$("#forcia-template-arrival-country0").html(html);
	},
	city0: function(ev) {
		if (ev.data.state.subLayer !== "city0") return;
		const cityData = viewHelpers.getCityData(ev.data, 0);
		const html = Templates.city0(Object.assign({cities: cityData, numFormat}, ev.data));
		$("#forcia-template-arrival-city0").html(html);
	},
	country1: function(ev) {
		if (ev.data.state.subLayer !== "country1") return;
		var store = ev.data;
		var html = Templates.country1(Object.assign({regions: viewHelpers.getMapData(store), numFormat}, store));
		$("#forcia-template-arrival-country1").html(html);
	},
	city1: function(ev) {
		if (ev.data.state.subLayer !== "city1") return;
		const cityData = viewHelpers.getCityData(ev.data, 1);
		const html = Templates.city1(Object.assign({cities: cityData, numFormat}, ev.data));
		$("#forcia-template-arrival-city1").html(html);
	},
	calendarBase: function(ev) {
		var store = ev.data;
		var monthHtmls = _.map(store.def.months, function(month, idx) {
			return Templates.calendarMonth(Object.assign({month: store.def.months[idx], idx}, store));
		});
		var html = Templates.calendarBase(Object.assign({monthHtmls: monthHtmls}, store));
		$("#forcia-template-calendar").html(html);
	},
	calendarMonth: function(ev) {
		var store = ev.data;
		var idx = Number(store.state.monthIndex);
		var html = Templates.calendarMonth(Object.assign({month: store.def.months[idx], idx}, store));
		$("#forcia-template-calendar-month-" + idx).html(html);
	},
	calendarCheckbox: function(ev) {
		const html = Templates.calendarCheckbox(ev.data);
		$("#forcia-template-calendar-checkbox").html(html);
	},
	calendarDate: function(ev) {
		if (!ev.data.state.checkStock) return;
		const total = +ev.data.state.ConditionState.dataCount[0];
		$(".forcia-calendar-date .act .num").html(`[${total}]`);
	},
	slideCalendar: function(ev) {
		slideCalendar(null, {
			selector: ".ipt_calWrap",
			index: ev.data.state.monthIndex
		});
	},
	kodawari: function(ev) {
		const store = ev.data;
		const categories = store.state.kodawariCategories;
		KODAWARI.forEach((category) => {
			$(category.selector).html(Templates.kodawari(Object.assign({
				kodawari: categories[category.name]
			}, store)));
		});
	},
	departure: function(ev) {
		var store = ev.data;
		var count = store.state.ConditionState.depAirportCount;
		var noselect = { index: 0, name: "指定なし", code: "", order: "0" };
		var airports = [noselect].concat(store.def.depAirport);

		var list = _.map(airports, function(airport) {
			return Object.assign({
				count: numFormat(count[Number(airport.index)] || 0),
				isSelected: airport.code === store.state.depAirport
			}, airport);
		});
		list.sort(function(a, b){return Number(a.order) - Number(b.order);});
		var html = Templates.departure({airports: list});
		$("#forcia-template-departure").html(html);
	},
	duration: function(ev) {
		var store = ev.data;
		var count = store.state.BudgetDurationState.duration;
		var durations = _.map(store.def.duration, function(duration, i) {
			return Object.assign({
				count: numFormat(count[i] || 0),
				chkStatus: viewHelpers.checkStatus(store.state.duration, String(duration.code), count[i])
			}, duration);
		});
		var html = Templates.duration(_.assign({duration: durations}, store));
		$("#forcia-template-duration").html(html);
	},
	budget: function(ev) {
		const store = ev.data;
		const count = store.state.BudgetDurationState.budget;
		if (!count) return;
		const budgets = store.def.budget.map(function(budget, i) {
			return Object.assign({
				count: numFormat(count[i] || 0),
				chkStatus: viewHelpers.checkStatus(store.state.budget, budget.code, count[i])
			}, budget);
		});
		const html = Templates.budget({budgets});
		$("#forcia-template-budget").html(html);
	},
	hotelName: function(ev) {
		$("#forcia-keyword-hotel").val(ev.data.state.hotelname);
	},
	freeword: function(ev) {
		$("#forcia-freeword").val(ev.data.state.freeword);
	},
	hotels: function(ev) {
		var store = ev.data;
		var page = store.state.reviewPage || 1;
		var start = (page - 1) * REVIEW_HOTELS_PER_PAGE;
		var hotelsInPage = store.state.hotels.slice(start, start + REVIEW_HOTELS_PER_PAGE);
		const noHotel = !store.state.hotels[0].hotel_code;
		const hotelCount = noHotel ? 0 : numFormat(store.state.hotels.length);
		const html = Templates.reviewHotels(Object.assign({
			noHotel: noHotel,
			numFormat: numFormat,
			hotelsInPage: hotelsInPage,
			tripAdvisorURL: viewHelpers.tripAdvisorURL
		}, store));
		$("#forcia-template-review-hotels").html(html);
		$("#forcia-bind-hotel-count").html(hotelCount);
		const hasPrev = page !== 1;
		const maxPage = viewHelpers.calcMaxPage(hotelCount, REVIEW_HOTELS_PER_PAGE);
		const hasNext = maxPage !== page;
		const pageHtml = Templates.reviewPage({hasNext, hasPrev});
		$("#forcia-template-review-page").html(pageHtml);
	},
	reviewMinMax: function(ev) {
		const state = ev.data.state;
		const minItems = ev.data.def.reviewValues.map((item) => {
			return Object.assign({
				selected: state.HotelMinPop === item.value ? "selected" : ""}, item);
		});
		const maxItems = ev.data.def.reviewValues.map((item) => {
			return Object.assign({
				selected: state.HotelMaxPop === item.value ? "selected" : ""}, item);
		}).filter((item) => (+item.value >= +state.HotelMinPop));
		$("#forcia-template-review-minvalue").html(Templates.reviewValue({items: minItems}));
		$("#forcia-template-review-maxvalue").html(Templates.reviewValue({items: maxItems}));
	},
	isOpenedLayer: function(ev) {
		//赤い一枚目のレイヤーを開くアニメーション (...method名が変. openLayer)
		if (ev.data.state.isOpenedLayer) {
			// デザイン上cssのみでアニメーション動作を実装するのが難しかったため、animateを使用している。
			// （jal.co.jpのmobileサイトもanimateが使われておりそれがデザインのベースになっているため。）
			$(".forcia-layer-main").animate({left: 0}, LAYER_SPEED, () => {
				$("body").css({backgroundColor: "#c41419"});
				$(".forcia-layer-main").css({position: "relative"});
				$("#wrapper").css({display: "none"});
				window.scrollTo(0, 0);
			});
			hash.openMain();
		} else {
			$(".forcia-layer-main").css({left: "120%", position: "fixed"});
			$("#wrapper").css({display: "block"});
			hash.closeMain();
		}
	},
	subLayer: function(ev) {
		//グレーの2枚目のレイヤーを開くアニメーション
		const subLayer = ev.data.state.subLayer;
		if (_.isEmpty(subLayer)) {
			const $sub = $(".forcia-layer-sub");
			$sub.css({left: "120%", position: "fixed"});
			$(".forcia-layer-main").css({display: "block"});
			hash.closeSub();
		} else {
			const $sub = $(`.forcia-layer-sub[data-layer="${subLayer}"]`);
			$("body").css({backgroundColor: "#e9ecf0"});
			$sub.animate({left: 0}, LAYER_SPEED, () => {
				$(`.forcia-layer-sub[data-layer!="${subLayer}"]`).css({left: "120%", position: "fixed"});
				$sub.css({position: "relative"});
				$(".forcia-layer-main").css({display: "none"});
				window.scrollTo(0, 0);
			});
			hash.openSub();
		}
	},
	modSortText: function(ev) {
		$("#forcia-sort .hotel").val(SORT.hotel_back.optionValue);
		$("#forcia-sort .hotel").text(SORT.hotel_back.text);
		ev.data.state.changedSortText = true;
	},
	initSortText: function(ev) {
		$("#forcia-sort .hotel").val(SORT.hotel.optionValue);
		$("#forcia-sort .hotel").text(SORT.hotel.text);
		ev.data.state.changedSortText = false;
	},
	goMultiHotelTours: function(ev, renderInfo) {
		if (renderInfo.isCheckOn) { //check on
			$("#popup-" + renderInfo.checkHotelCode).show();
			viewHelpers.adjustCassetteSpace("remove", renderInfo.checkedCassette);
		} else { //check off
			$("#popup-" + renderInfo.checkHotelCode).hide();
			viewHelpers.adjustCassetteSpace("add", renderInfo.checkedCassette);
		}
	},
	hotelSortTextControler: function(ev) {
		const store = ev.data;
		function isBack(store) {
			const currentParams = store.state.getParam();
			const lastParams = store.state.hotelOrderLastParam || {};
			let back;
			if (store.state.hotelSortForDetailBack && store.state.hotelSortForDetailBack === "isBack") {
				//詳細画面から戻ってきた場合
				store.state.hotelOrderLastParam = currentParams;
				delete store.state.hotelSortForDetailBack;
				back = true;
			} else if (currentParams.sort !== "hotel_back" && viewHelpers.compareParams(currentParams, lastParams)) {
				back = true;
			} else {
				back = false;
			}
			return back;
			//return currentParams.sort !== "hotel_back" && viewHelpers.compareParams(currentParams, lastParams);
		}
		if (isBack(store)) {
			this.modSortText(ev);
			store.state.set({hotelSort: "isBack"});
		} else {
			this.initSortText(ev);
			store.state.set({hotelSort: "isNotBack"});
		}
	}
};

// 初期描画時、検索条件に詳細設定が選択されていたら開いた状態にしておく
let isInit = true;
function initDetailConditionDisplay(store) {
	if (isInit) {
		store.state.detailSelected &&
			document.querySelector(".ipt_main_body .forcia-slide-toggle").click();
	}
	isInit = false;
}



// WEBPACK FOOTER //
// ./web/WEB-INF/js/client/search/view.js